import { LicenseWebPageRequest, LicenseWebPageResponse } from 'commons/types/DTO/bank'
import { Request } from 'commons/utils/request/request'

export const deleteLicense = (id: number) => Request.delete(Request.urls.bank.license, { id })

export const getLicenseWebPage = (form?: LicenseWebPageRequest): Promise<LicenseWebPageResponse> =>
  Request.post(Request.urls.bank.licenseDetails, form)
